<div class="flex-content">

  <div class="content col-sm-12 container-fluid">
    
    <div class="row">
      <div *ngFor="let person of person$ | async"  class="person-img">
        <img class="personimg" default="./assets/imgs/no_image.jpg" 
            [srcset]=" imgPath + person.img"
            [src]=" imgPath + person.img"
            >

        <h5 class="email-left" *ngIf="person.email">E-mail</h5>
        <p class="email-left">{{person.email}}</p>

        <h5 class="email-left" *ngIf="person.email">Book</h5>
        <p class="email-left">틀을 깨려는 용기가 필요해 </p>
        <img style="cursor:pointer;" class="email-left prof__book book"(click)="navigateToBook()" src="https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9788956244501.jpg" >

      </div>


      <div class="person-desc">
        <div *ngFor="let person of person$ | async">
          <h1>{{person.name}}</h1>
          <p class="email-right">{{person.email}}</p>
          <p>KAIST Chair Professor</p>
          <div *ngIf="person.affiliation;then content else other_content">here is ignored</div>

          <ng-template #content><p>{{person.affiliation}}</p></ng-template>
          <ng-template #other_content><p>Visual Media Lab <br> Graduate School of Culture and Technology, KAIST</p></ng-template>

          
          <p (click)="navigateToBook()" class="link email-right">BOOK : 틀을 깨려는 용기가 필요해 </p>

          <hr/>

          <h3>Research Interests</h3>
          <div>
            <p class="topics">{{person.topics}}</p>
          </div>
          <hr/>
        </div>

        <div>
          <h3>Education</h3>
          <table class="table">
            <tbody>
              <tr *ngFor="let edu of education$ | async">
                <td class="table-left">
                  <span *ngIf='(edu.since).length > 0 '>{{edu.since}}</span>
                  <span *ngIf='(edu.until).length > 0 '>{{edu.until}}</span>
                </td>
                <td>
                  <p>{{edu.main}}</p>
                  <sub>{{edu.sub}}</sub>
                </td>
              </tr>
            </tbody>
          </table>
          <hr/>
        </div>

        <div>
          <h3>Appointments</h3>
          <table class="table">
            <tbody>
              <tr *ngFor="let app of appointment$ | async">
                <td class="table-left">
                  <span *ngIf='(app.since).length > 0 '>{{app.since}} </span>
                  <span>- </span>
                  <span *ngIf='(app.until).length > 0 '>{{app.until}}</span>
                </td>
                <td>
                  <p>{{app.main}}</p>
                  <sub>{{app.sub}}</sub>
                </td>
              </tr>
            </tbody>
          </table>
          <hr/>
        </div>

      </div>
    </div>
  </div>
</div>





// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/proffessor/proffessor.component.html